import { QueryKey } from '@tanstack/react-query';

export const usersQueryKeys: Record<string, QueryKey> = {
  getUserInfo: ['userInfo'],
} as const;
